module.exports = new __parcel__URL__("nature_soundscape.d2549a07.mp3").toString();